import styled from 'styled-components';
import ColorConstants from '../../../constants/ColorConstants';

export const CountryWrapper = styled.div`
  display: flex;
  align-itens: flex-end;
`;

export const NoFlag = styled.div`
  width: 23px;
  height: 23px;
  margin: 0 5px;
  background-color: ${ColorConstants.GRAY_5}
`;

export const flagStyle = {
    width: '23px',
    height: '23px',
    margin: '0 5px',
};
